import {
  sanitizeRichHtml,
  sanitizeLegacyInlineHtml,
  USER_CONTENT_RICH_CLASS,
} from '../../../utils/userContentSanitize';
import styles from '../CommentList.module.scss';

/**
 * Renders TipTap HTML, or legacy plain text with @mentions + URL linkification.
 */
export function CommentRichText({ text, mentionedHandles }) {
  if (!text) return null;

  if (text.startsWith('<')) {
    return (
      <p
        className={`${styles.commentText} ${USER_CONTENT_RICH_CLASS}`}
        dangerouslySetInnerHTML={{
          __html: sanitizeRichHtml(text),
        }}
      />
    );
  }

  const confirmedSet = mentionedHandles
    ? new Set(mentionedHandles.map((h) => h.toLowerCase()))
    : null;

  const textWithMentions = text.replace(
    /(^|[\s\n])@([a-z0-9_]+)/gi,
    (match, prefix, handle) => {
      if (confirmedSet && !confirmedSet.has(handle.toLowerCase())) return match;
      return `${prefix}<a href="/user/@${handle}" data-mention-handle="${handle}">@${handle}</a>`;
    }
  );

  const urlPattern =
    /(https?:\/\/[^\s]+|www\.[^\s]+|[^\s]+\.[a-z]{2,}(?:\/[^\s]*)?)/gi;
  const textWithLinks = textWithMentions.replace(urlPattern, (url) => {
    if (url.includes('href=')) return url;
    const fullUrl = url.startsWith('http') ? url : `https://${url}`;
    const maxLength = 50;
    const displayUrl =
      url.length > maxLength ? `${url.slice(0, maxLength)}...` : url;
    return `<a href="${fullUrl}" target="_blank" rel="noopener noreferrer">${displayUrl}</a>`;
  });

  const textWithBreaks = textWithLinks.replace(/\n/g, '<br>');
  const sanitizedHTML = sanitizeLegacyInlineHtml(textWithBreaks);

  return (
    <p
      className={`${styles.commentText} ${USER_CONTENT_RICH_CLASS}`}
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  );
}
